import { Flex, Heading, Text } from '@moonpig/launchpad-components'
import { getDepartmentTitle } from '@moonpig/web-core-utils'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC } from 'react'
import { AlternativeDepartmentResultsHeaders } from '../AlternativeDepartmentResultsHeaders/AlternativeDepartmentResultsHeaders'
import { capitaliseFirstCharacter } from '../../utils'
import { useFindLocaleText } from '../../text-localisation'
import { ContactUsCarousel } from '../ContactUsCarousel'
import type { SearchContext } from '../../store/slices/shared'

const StyledHeader = styled(Flex)`
  flex-flow: column wrap;
  align-items: flex-start;
`
type Props = {
  searchContext: SearchContext
}

export const ZeroResultsHeader: FC<Props> = ({ searchContext }) => {
  const { searchTerm, departments } = searchContext
  const departmentName = `${capitaliseFirstCharacter(
    getDepartmentTitle(departments[0]),
  )}`
  const localiseText = useFindLocaleText()

  return (
    <>
      <StyledHeader>
        <Heading level="h4" mr={4} mb={0} typography="typeBodyText">
          <strong>{localiseText('find.we_have_0_search_results')}</strong>{' '}
          {localiseText('find.for')} <strong>&quot;{searchTerm}&quot;</strong>{' '}
          {localiseText('find.in')}{' '}
          <strong>
            {localiseText('find.department', {
              departmentName,
            })}
          </strong>
          {'. '}
          {searchContext.departmentCounts?.length && (
            <AlternativeDepartmentResultsHeaders
              searchContext={searchContext}
              isZeroResults
            />
          )}
        </Heading>
        <ContactUsCarousel searchTerm={searchTerm} />
        <Text as="p" lineHeight={{ xs: 2, md: 1.5 }} mt={4}>
          {localiseText('find.products_you_may_also_like')}
        </Text>
      </StyledHeader>
    </>
  )
}
